import { render, staticRenderFns } from "./PronovaDoor.vue?vue&type=template&id=9453b1a4&scoped=true&"
import script from "./PronovaDoor.vue?vue&type=script&lang=js&"
export * from "./PronovaDoor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9453b1a4",
  null
  
)

export default component.exports